import {
  SUPERSET_AINA_CONTRIBUTION,
  SUPERSET_AINA_CONTRIBUTION_SUCCESS,
  SUPERSET_AINA_CONTRIBUTION_ERROR,
  SUPERSET_AINA_CONTRIBUTION_EMPTY,
} from '../../../../actionType';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupersetAINAContribution = (state = initialState, action) => {
  switch (action.type) {
    case SUPERSET_AINA_CONTRIBUTION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_AINA_CONTRIBUTION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPERSET_AINA_CONTRIBUTION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPERSET_AINA_CONTRIBUTION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupersetAINAContribution;
